import { ScoreBadge } from './score-badge';
import { TeamFitBadge } from './team-fit-badge';

interface ScoreRowProps {
  heuristicScore: string | null;
  aiScore: string | null;
  teamFitScore: string | null;
  layout?: 'inline' | 'grid';
}

export function ScoreRow({
  heuristicScore,
  aiScore,
  teamFitScore,
  layout = 'inline'
}: ScoreRowProps) {
  if (layout === 'grid') {
    return (
      <div className="grid grid-cols-3 gap-3">
        <div className="rounded-lg border p-3 text-center">
          <p className="text-[10px] text-muted-foreground">Heuristic</p>
          <div className="mt-1">
            <ScoreBadge score={heuristicScore} />
          </div>
        </div>
        <div className="rounded-lg border p-3 text-center">
          <p className="text-[10px] text-muted-foreground">AI Score</p>
          <div className="mt-1">
            <ScoreBadge score={aiScore} />
          </div>
        </div>
        <div className="rounded-lg border p-3 text-center">
          <p className="text-[10px] text-muted-foreground">Team Fit</p>
          <div className="mt-1">
            <TeamFitBadge score={teamFitScore} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      {aiScore && (
        <div className="flex items-center gap-1.5">
          <span className="text-[10px] text-muted-foreground">AI:</span>
          <ScoreBadge score={aiScore} />
        </div>
      )}
      {heuristicScore && (
        <div className="flex items-center gap-1.5">
          <span className="text-[10px] text-muted-foreground">Heuristic:</span>
          <ScoreBadge score={heuristicScore} />
        </div>
      )}
      {teamFitScore && (
        <div className="flex items-center gap-1.5">
          <span className="text-[10px] text-muted-foreground">Team Fit:</span>
          <TeamFitBadge score={teamFitScore} />
        </div>
      )}
    </div>
  );
}
